import React, { useEffect, useState } from 'react';
import MensagemCard from "../../Components/MensagemCard";
import clsx from 'clsx';
import _ from 'lodash';
import { FuseAnimate } from "@fuse";
import { Collapse, Typography } from "@material-ui/core";
import Factory from "../../Formatadores/Factory";
import { __esModule } from "react-select";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import PaginadorApp from "app/Core/Components/Paginador/PaginadorApp";
import MostrarMais from "../../Components/MostrarMais";

const CentralNotificacoesListagem = (props) => {

    const { open = null, nextPage, idlocal, Comunicador, updateDataLeitura, data = null, parametros, user, xappRouteParams, theme, locais, save, callback, getFilter, setOpenMessage } = props;

    const [openNaoLidas, setOpenNaoLidas] = useState(true);
    const [openLidas, setOpenLidas] = useState(true);


    const ANaoLidas = _.orderBy(_.filter(data, { lido: 0 }), "dataupt", "asc");
    const ALidas = _.orderBy(_.filter(data, { lido: 1 }), "dataupt", "desc");

    return (
        <div className={clsx("flex p-12 w-full h-full overflow-hidden gap-8")}>
            {!_.isNull(idlocal) ?
                <div className="w-full overflow-y-auto overflow-x-hidden">
                    {ANaoLidas.length > 0 &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => setOpenNaoLidas(!openNaoLidas)}>
                                <Typography className="inline font-medium text-17" color="textSecondary" paragraph={false}>
                                    {"Não lidas"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={openNaoLidas ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={openNaoLidas}>
                                {ANaoLidas.length > 0 ? (
                                    <div>
                                        {ANaoLidas.map(item => (
                                            <MensagemCard
                                                data={item}
                                                xappRouteParams={xappRouteParams}
                                                expanded={open}
                                                theme={theme}
                                                parametros={parametros}
                                                locais={locais}
                                                save={save}
                                                getFilter={getFilter}
                                                showTags={parametros.idlocal !== -1}
                                                callback={callback}
                                                setOpenMessage={setOpenMessage}
                                                Comunicador={Comunicador}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <div className="flex flex-col flex-1 items-center justify-center p-16">
                                        <div className="max-w-512 text-center">
                                            <FuseAnimate delay={300}>
                                                <Typography color="textSecondary" className="inline font-medium text-16 mb-16">
                                                    {"Não existem registros cadastrados!"}
                                                </Typography>
                                            </FuseAnimate>
                                        </div>
                                    </div>
                                )}

                            </Collapse>
                        </React.Fragment>
                    }
                    <div className="flex px-8 items-center cursor-pointer" onClick={() => setOpenLidas(!openLidas)}>
                        <Typography className="inline font-medium text-17" color="textSecondary" paragraph={false}>
                            {"Mensagens lidas"}
                        </Typography>
                        <div className="flex-1" />
                        <XAPPButton
                            noHover={true}
                            type="icon"
                            icon={openLidas ? "arrow_up" : "arrow_down"}
                            onClick={() => { }}
                        />
                    </div>
                    <Collapse in={openLidas}>
                        {ALidas.length > 0 ? (
                            <div>
                                {ALidas.map(item => (
                                    <MensagemCard
                                        data={item}
                                        xappRouteParams={xappRouteParams}
                                        expanded={open}
                                        theme={theme}
                                        parametros={parametros}
                                        locais={locais}
                                        save={save}
                                        getFilter={getFilter}
                                        showTags={parametros.idlocal !== -1}
                                        callback={callback}
                                        setOpenMessage={setOpenMessage}
                                        Comunicador={Comunicador}
                                    />
                                ))}
                            </div>
                        ) : (
                            <div className="flex flex-col flex-1 items-center justify-center p-16">
                                <div className="max-w-512 text-center">
                                    <FuseAnimate delay={300}>
                                        <Typography color="textSecondary" className="inline font-medium text-16 mb-16">
                                            {"Não existem registros cadastrados!"}
                                        </Typography>
                                    </FuseAnimate>
                                </div>
                            </div>
                        )}
                    </Collapse>
                    {!_.isNull(data) && data.length > 0 &&
                        <MostrarMais
                            nextPage={nextPage}
                            pagina={Comunicador.pagina}
                            paginas={Comunicador.paginas}
                        />
                    }
                </div>
                :
                <div className="flex flex-col flex-1 items-center justify-center p-16">
                    <div className="max-w-512 text-center">
                        <FuseAnimate delay={300}>
                            <Typography color="textSecondary" className="inline font-medium text-16 mb-16">
                                {"Selecione um local para ver as mensagens!"}
                            </Typography>
                        </FuseAnimate>
                    </div>
                </div>
            }
            {!_.isNull(data) && !_.isNull(open) && open?.interacao === 1 &&
                <div className="flex flex-col w-3/5 border-1 p-6" style={{ "height": "65vh" }}>
                    <Factory
                        user={user}
                        xappRouteParams={xappRouteParams}
                        data={open}
                        formatador="chat"
                        save={save}
                        theme={theme}
                        updateDataLeitura={updateDataLeitura}
                    />
                </div>
            }
        </div >
    );
}

export default CentralNotificacoesListagem;